"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _common = require("react-color/lib/components/common");

var _pointer = _interopRequireDefault(require("./pointer"));

var _PhotoshopPointerCircle = _interopRequireDefault(require("react-color/lib/components/photoshop/PhotoshopPointerCircle"));

function ColorPicker(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative",
      height: 150,
      marginTop: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_common.Saturation, Object.assign({}, props, {
    pointer: _PhotoshopPointerCircle.default
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative",
      height: 10,
      marginTop: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_common.Hue, Object.assign({}, props, {
    pointer: _pointer.default
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative",
      height: 10,
      marginTop: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_common.Alpha, Object.assign({}, props, {
    pointer: _pointer.default
  }))));
}

var _default = (0, _common.ColorWrap)(ColorPicker);

exports.default = _default;